import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import {EMPTY_VALUES} from "../Apis/functions";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param String title
 * @param String value
 * @param String className
 * @returns {JSX.Element}
 */
const RowResumeText = ({ title, value = [], className, tooltip = '', Icon }) => {
    const { t } = useTranslation();
    const elementRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        if (elementRef.current) {
            const spanElement = elementRef.current;
            if (spanElement) {
                setIsTruncated(spanElement.scrollWidth > spanElement.clientWidth);
            }
        }
    }, [value]);

    return (
        <div className={'row-resume ' + className}>
            <h6 className=' mb-1 ibl-font-w-600 fs-14px d-flex align-items-center gap-2'>{t(title)}</h6>
            {Array.isArray(value) ? (
                <ul className='mb-0 ibl-font-w-300 ibl-label list-unstyled'>
                    {value.map((item, idx) => (
                        <li key={idx} className='text-body'>
                            {item}
                        </li>
                    ))}
                </ul>
            ) : isTruncated && tooltip ? (
                <Tooltip title={tooltip} placement='top'>
                    <span
                        ref={elementRef}
                        className={
                            'resume-text mb-0 fs-14px d-inline-flex align-items-center gap-2 text-wrap' +
                            (tooltip ? ' text-truncate' : '')
                        }
                    >
                        {Icon && <Icon className='icon-color-general-950 h-16px w-16px' />}
                        {value || EMPTY_VALUES.DEFAULT}
                    </span>
                </Tooltip>
            ) : (
                <span
                    ref={elementRef}
                    className={'resume-text mb-0 fs-14px d-inline-block text-wrap' + (tooltip ? ' text-truncate' : '')}
                >
                    {Icon && <Icon className='icon-color-general-950 h-16px w-16px mr-2' />}
                    {value || EMPTY_VALUES.DEFAULT}
                </span>
            )}
        </div>
    );
};

export default RowResumeText;
